import React from 'react';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Link } from 'react-router-dom';
import './Storefront.css';

type PublicLayoutProps = {
    children: React.ReactNode;
    compact?: boolean;
    showChrome?: boolean;
};

export const PublicLayout: React.FC<PublicLayoutProps> = ({
    children,
    compact = false,
    showChrome = true,
}) => (
    <div className={`saas-public-page${compact ? ' saas-public-page--compact' : ''}${
        showChrome ? '' : ' saas-public-page--embedded'
    }`}>
        {showChrome && (
            <header className='saas-header'>
                <Link to='/plans' className='saas-brand' aria-label='SuperPenguin plans'>
                    <img src={require('../components/assets/superpenguin-logo.webp')} alt='SuperPenguin' />
                </Link>
                <nav aria-label='Account navigation'>
                    <Link to='/'>Sign in</Link>
                </nav>
            </header>
        )}
        {children}
        {showChrome && (
            <footer className='saas-footer'>
                <span>© {new Date().getFullYear()} BeneTalk Ltd</span>
                <div>
                    <a href='https://www.superpenguin.com' target='_blank' rel='noreferrer'>SuperPenguin</a>
                    <a href='mailto:support@superpenguin.com'>Contact</a>
                </div>
            </footer>
        )}
    </div>
);

export const PublicLoading: React.FC<{ message?: string }> = ({ message = 'Loading…' }) => (
    <main className='saas-status-page' aria-live='polite'>
        <span className='saas-spinner' aria-hidden='true' />
        <h1>{message}</h1>
    </main>
);

export const PublicError: React.FC<{
    title: string;
    message: string;
    onRetry?: () => void;
    retryLabel?: string;
    returnTarget?: '_top';
    returnPath?: string;
    returnLabel?: string;
    reloadReturn?: boolean;
}> = ({
    title,
    message,
    onRetry,
    retryLabel = 'Try again',
    returnTarget,
    returnPath = '/plans',
    returnLabel = 'Return to plans',
    reloadReturn = false,
}) => (
    <main className='saas-status-page' role='alert'>
        <span className='saas-status-icon saas-status-icon--error' aria-hidden='true'>
            <ErrorOutlineRoundedIcon fontSize='inherit' />
        </span>
        <h1>{title}</h1>
        <p>{message}</p>
        {onRetry && <button type='button' className='saas-button' onClick={onRetry}>{retryLabel}</button>}
        {reloadReturn ? (
            <a href={returnPath} className='saas-text-link' target={returnTarget}>{returnLabel}</a>
        ) : (
            <Link to={returnPath} className='saas-text-link' target={returnTarget}>{returnLabel}</Link>
        )}
    </main>
);
